import { useEffect, useState } from "react";

export const History = ({ loaId, authToken }) => {
  const [history, setHistory] = useState([]);

  useEffect(() => {
    if (!loaId || !authToken) return;

    fetch(
      `${process.env.REACT_APP_BACKEND_URL}/API/V2/LOA/${loaId}/history`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      },
    )
      .then((response) => {
        if (response.status === 401) {
          window.location.href = process.env.REACT_APP_JBM_LOGIN_URL;
          return null;
        }
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.json();
      })
      .then((responseData) => {
        if (Array.isArray(responseData)) setHistory(responseData);
      })
      .catch((err) => console.error("History fetch error:", err));
  }, [loaId, authToken]);

  if (history.length === 0) {
    return (
      <div className="bg-white rounded-xl p-6 shadow-[0_2px_8px_rgba(0,0,0,0.05)] text-xs">
        <p className="text-gray-500">No history available.</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl p-6 shadow-[0_2px_8px_rgba(0,0,0,0.05)] text-xs overflow-x-auto">
      <table className="min-w-full border-collapse">
        <thead>
          <tr>
            <th className="text-left p-2.5 bg-gray-50 border-b border-gray-200">Changed By</th>
            <th className="text-left p-2.5 bg-gray-50 border-b border-gray-200">Timestamp</th>
            <th className="text-left p-2.5 bg-gray-50 border-b border-gray-200">Changes</th>
          </tr>
        </thead>
        <tbody>
          {history.map((entry, index) => (
            <tr key={index}>
              <td className="p-2.5 border-b border-gray-100">{entry.changedBy}</td>
              <td className="p-2.5 border-b border-gray-100 whitespace-nowrap">
                {new Date(entry.timestamp).toLocaleString("en-IN", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                })}
              </td>
              <td className="p-2.5 border-b border-gray-100">
                <ul className="list-none m-0 p-0">
                  {entry.changes.map((change, idx) => (
                    <li key={idx}>
                      <strong>{change.field}:</strong>{" "}
                      {typeof change.oldValue === "object"
                        ? JSON.stringify(change.oldValue)
                        : String(change.oldValue)}{" "}
                      →{" "}
                      {typeof change.newValue === "object"
                        ? JSON.stringify(change.newValue)
                        : String(change.newValue)}
                    </li>
                  ))}
                </ul>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
